import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import { Documents } from ".";
import { useParams } from "react-router-dom";

export const ChartBar = ({ data }: Documents) => {
  const { getSizesComponent, setFontSize, componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);
  const [labels, setLabels] = useState<string[]>([]);
  const [dataChart, setDataChart] = useState<number[]>([]);
  const { mode } = useParams();

  useEffect(() => {
      delete data.total;
      setLabels(Object.keys(data))
      setDataChart(Object.values(data))
  }, [data]);

const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          const selected = labels[config.dataPointIndex];
          let status = [];
  
          switch (selected) {
            case "Entregue":
              status = [3, 4, 8];
              break;
            case "Devolvido":
              status = [13];
              break;
            case "Não Entregue":
              status = [6,9];
              break;
            case "Pendente":
              status = [0,1,2,5,7,10,11,18];
              break;
            case "Transferido":
              status = [17];
              break;
            case "Agendado":
              status = [15,20];
              break;
            case "Sem rota":
              status = [12];
              break;

            default:
              status = [3, 4, 8];
              break;
          }

          if (
            mode === "view" 
            &&
            componentProperty({
              id: "chartDocumentsDeliveredPerSlaDetailed",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartDocumentsDeliveredPerSlaDetailed", {
                redirectTowerToIndex: true,
                date: true,
                slaDate: true,
                status_stop_id: status
              }),
              "_blank"
            );
          }
        },
      },
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        distributed: true,
        horizontal: true,
        dataLabels: { position: "bottom" },
      },
    },
    colors: ["#01B8AA", "#7c834d", "#FF0000", "#808080", "#3CB371","#8105AA", "#7B9233"],
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      formatter: function (val, opt) {
        return labels[opt.dataPointIndex] + ":  " + val;
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: { position: "bottom" },
        },
      },
    ],
    yaxis: {
      labels: {
        show: false,
      },
    },
    xaxis: {
      max: Math.max(...dataChart),
      range: 7,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    labels: labels,
    tooltip: { enabled: false },
    legend: { show: false },
  };

  const series = [
    {
      data: dataChart,
    },
  ];

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-documents-delivered-per-sla-detailed" });
    if (sizes.width < 345) {
      setFontSize({ id: "chartDocumentsDeliveredPerSlaDetailed", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Entregas por SLA`}
        clickable={componentProperty({
          id: "chartDocumentsDeliveredPerSlaDetailed",
          property: "redirect",
        })}
        id="chart-documents-delivered-per-sla-detailed"
      />
      <div id="chart">
        <Chart
          type="bar"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <></>
  );
};
